/* eslint-disable no-use-before-define */
import { uniqBy } from 'lodash';
import { isIntermodalShipmentType } from './shipment-types';
const getLocationForAction = (stops, action) => {
    let targetStop = stops.find((stop) => stop.action === action && !stop.empty);
    if (!targetStop) {
        targetStop = stops.find((stop) => stop.action === action);
    }
    if (!targetStop || !targetStop.location) {
        return '';
    }
    const { location } = targetStop;
    if (Array.isArray(location) && location.length > 0) {
        return location[0];
    }
    return location;
};
const getEquipments = (stops) => {
    const equipments = stops.reduce((equipmentList, stop) => {
        const stopEquipments = stop.equipments || [];
        return equipmentList.concat(stopEquipments);
    }, []);
    return uniqBy(equipments, (eq) => eq._id);
};
function mapStop(stop) {
    const { sequence, action, empty, appointment, window_start, window_end, location, reference_numbers, equipments, contacts, } = stop;
    const hazards = stop.hazards || [];
    return {
        sequence,
        action,
        empty,
        appointment,
        window_start,
        window_end,
        location,
        contacts,
        reference_numbers,
        hazards,
        equipments: equipments.map(mapEquipment),
    };
}
function mapEquipment(equipment) {
    const { _id, equipment_id, _type, _equipmentType } = equipment;
    return {
        _id,
        equipment_id,
        _type,
        _equipmentType,
    };
}
export function mapStagingShipment(shipment) {
    const { _id, carrier, carrier_id, carrier_cost, shipper_cost, shipment_type, special_instructions, reference_numbers, stops: unmappedStops, weight, receivables, } = shipment;
    const stops = (unmappedStops || []).map(mapStop);
    return {
        shipment_id: '',
        status: 'en_route',
        equipments: getEquipments(stops),
        pickup: getLocationForAction(stops, 'pickup'),
        deliver: getLocationForAction(stops, 'deliver'),
        return: getLocationForAction(stops, 'return'),
        _id,
        carrier,
        carrier_id,
        carrier_cost,
        shipper_cost,
        shipment_type,
        special_instructions,
        reference_numbers,
        stops,
        isStaging: true,
        weight,
        receivables,
    };
}
export function mapOrderShipment(shipment) {
    const { _id, current, accepted, shipment_id, status, billing_status, delivery_order_sent, missing_docs, shipment_type, carrier_name, carrier, shipper, stops: unmappedStops, documents, payables, receivables, needs_invoice, needs_payout, timeline, market, } = shipment;
    const stops = (unmappedStops || []).map(mapStop);
    const equipments = getEquipments(stops);
    return {
        _id,
        current,
        accepted,
        shipment_id,
        status,
        billing_status,
        delivery_order_sent,
        shipment_type,
        carrier_name,
        carrier,
        shipper,
        stops,
        equipments,
        documents,
        payables,
        receivables,
        needs_invoice,
        needs_payout,
        timeline,
        missing_docs,
        pickup: getLocationForAction(stops, 'pickup'),
        deliver: getLocationForAction(stops, 'deliver'),
        return: getLocationForAction(stops, 'return'),
        isStaging: false,
        market,
    };
}
export const getMaxAdjustmentRate = (mileDistance) => {
    if (typeof mileDistance === 'undefined' || mileDistance === null) {
        return 0;
    }
    if (mileDistance >= 0 && mileDistance <= 5) {
        return 500.0;
    }
    if (mileDistance > 5 && mileDistance <= 15) {
        return 200.0;
    }
    if (mileDistance > 15 && mileDistance <= 25) {
        return 100.0;
    }
    if (mileDistance > 25 && mileDistance <= 40) {
        return 50.0;
    }
    if (mileDistance > 40 && mileDistance <= 125) {
        return 20.0;
    }
    if (mileDistance > 125 && mileDistance <= 250) {
        return 10.0;
    }
    return 15.0;
};
export const isActiveIntermodalShipment = (job) => {
    return job.current && !job.canceled && isIntermodalShipmentType(job);
};
